export { HighlightFrame } from "./HighlightFrame"
export type { HighlightFrameProps } from "./HighlightFrame"
